export const REACT_APP_MY_LLS_PORTAL = "https://my.languageline.com/portal";
export const LLS_HOME_URL = "https://www.languageline.com";
export const TELEPERFORMANCE_PRIVACY_URL =
  "https://www.teleperformance.com/en-us/data-privacy-information-and-inquires";
